import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { shareToQQZone, shareToWeiBo, shareToQQ, shareToTieBa } from '@src/utils/page-share';
import { shareUrl, shareTitle, shareDesc } from '@src/utils/share';
import { observable, computed } from 'mobx';
import { noop } from '@src/utils/common-util';
import copy from '@src/components/copy';
import $$tracker from '@src/tracker';
import { aLink } from '@src/utils/common-util';
class ShareModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  // 分享成功回调
  @observable successCallback = noop;
  // 是否已经分享过
  @observable hadShare = false;

  shareData = {
    url: shareUrl(),
    title: shareTitle(),
    des: shareDesc()
  };

  // 分享配置
  shareConfig = [
    {
      key: 'qq',
      icon: require('./images/share-qq.png'),
      onShare: () => {
        aLink(
          'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=ESU7Uxq81QGXTsP3h-nIK0-PmckarYBc&authKey=6k8kE4yEbAa2QLwbjqIZiafUue4S28ujhJDro1TAKuZw0WRCbdR5HK0%2B3hyGZyyo&noverify=0&group_code=868421507'
        );
        $$tracker.clickShare('QQ', '抽奖任务');
        this.hadShare = true;
        this.successCallback();
      }
    },
    {
      key: 'tieba',
      icon: require('./images/share-tieba.png'),
      onShare: () => {
        shareToTieBa({
          ...this.shareData
        });
        $$tracker.clickShare('贴吧', '抽奖任务');
        this.hadShare = true;
        this.successCallback();
      }
    },
    {
      key: 'qqZone',
      icon: require('./images/share-qqZone.png'),
      onShare: () => {
        shareToQQZone({
          ...this.shareData
        });
        $$tracker.clickShare('空间', '抽奖任务');
        this.hadShare = true;
        this.successCallback();
      }
    },
    {
      key: 'weibo',
      icon: require('./images/share-weibo.png'),
      onShare: () => {
        shareToWeiBo({
          ...this.shareData,
          url: ''
        });
        $$tracker.clickShare('微博', '抽奖任务');
        this.hadShare = true;
        this.successCallback();
      }
    },

    {
      key: 'link',
      icon: require('./images/share-link.png'),
      onShare: () => {
        copy(window.location.href, { successPreText: '复制链接成功，快去分享给好友吧' });
        $$tracker.clickShare('复制链接', '抽奖任务');
        this.hadShare = true;
        this.successCallback();
      }
    }
  ];

  /**
   * 点击关闭按钮
   * 如果需要自定义关闭事件, 则可以重写
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.hadShare = false;
    this.clearStyle();
  };

  use() {
    super.use();
  }
}

export default ShareModalStore;
